export const exportHeaders = [
    { 
        label: "Promotion Id", 
        key: "promotion_id" 
    },
    { 
        label: "Category", 
        key: "category" 
    },
    { 
        label: "Category Value", 
        key: "category_value" 
    },
    { 
        label: "Status", 
        key: "is_active" 
    },
    { 
        label: "Loyalty Organization Name", 
        key: "loyalty_organization_name" 
    },
    { 
        label: "Loyalty Site Id", 
        key: "loyalty_site_id" 
    }
]